'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'ProductDescription';

export const productDescriptionTemplateTypeKey = {
    standard: 'standard',
    accordion: 'accordion',
};

export enum OFFICIAL_PRODUCT_DESCRIPTION_TYPE_KEY {
    PRODUCT_DESCRIPTION = 'productDescription',
}

export const showCutList = [
    {
        key: OFFICIAL_PRODUCT_DESCRIPTION_TYPE_KEY.PRODUCT_DESCRIPTION,
        type: ELEMENT_TYPE.PRODUCT_DESCRIPTION,
        content: i18n.gettext('商品段落'),
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.PRODUCT_DESCRIPTION,
    name: componentName,
    enable: true, // 通常要開啟
    next: null,
    deletable: false, // 通常要開啟
};

export const features = [
    FEATURE_FLAG_KEYS.PRODUCT_DESCRIPTION_TEMPLATE_TYPE,
    FEATURE_FLAG_KEYS.ANIMATION,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.PRODUCT_DESCRIPTION_TEMPLATE_TYPE]:
        productDescriptionTemplateTypeKey.standard,
} as const;

export function createProductDescription(presetStyle?: LayoutNodeStyleMap[string]) {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
    };
}

export function generate(
    sectionName: string = i18n.gettext('區塊'),
    options?: { shouldWrap?: boolean }
) {
    const productDescription = createProductDescription();

    const shouldWrap = options?.shouldWrap ?? true;

    return combineComponent(sectionName, [productDescription], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        shouldWrap,
    });
}
